import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { CounterProps } from '../types';
import { Size } from '../enums';
import { Basic } from '../basic';
import { Typography } from '../typography';
import { sizePresets } from './model';
import css from './style.module.css';

export const Layout = forwardRef<HTMLSpanElement, CounterProps>(
  function Component(
    { className, size = Size.SMALL, children, ...props },
    forwardedRef
  ) {
    return (
      <Basic
        {...props}
        className={clsx(className, css.root, sizePresets[size])}
        ref={forwardedRef}
      >
        <Typography className={css.inner} size={size}>
          {children}
        </Typography>
      </Basic>
    );
  }
);
